module.exports = __webpack_public_path__ + "img/shop-map2.82b89933.jpg";